import { isKiosk } from './platform';
import { getQuery, rangeShouldEnableFullRoom } from './queryUtils';
export const isSpaceEnabled = () => getQuery().get('enableSpacePlanning') === 'true';
export const isFullRoomEditorEnabled = () => rangeShouldEnableFullRoom() || getQuery().get('enableFullRoomEditor') === 'true';
export const isInnerWallsAndObstaclesEnabled = () => getQuery().get('enableInnerWallsAndObstacles') === 'true';
export const isRemoveInnerWallsEnabled = () => getQuery().get('enableRemoveInnerWalls') === 'true';
export const isRailingsEnabled = () => getQuery().get('enableRailings') === 'true';
export const isGalleryActive = () => isKiosk() && getQuery().get('ipexGallery') === 'true';
export const isUpptackaActive = () => isKiosk() && getQuery().get('origin') === 'upptacka';
export const anyIntegrationActive = () => isKiosk() && (isUpptackaActive() || isGalleryActive());
export const isEarlyAccessEnabled = () => getQuery().get('enableEarlyAccess') === 'true';
//# sourceMappingURL=integration.js.map